import React, { useState, useEffect } from "react";
import { Button } from "@material-ui/core";
import "./style.scss";
import {
  getViewApplicationData,
  updateApplicationStatus,
} from "./dependencies/action";
import { connect } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import SubmitAction from "../../../SubmitAction";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import swal from "sweetalert";
import api from "../../../../common/dependencies/utils/Api";
import {
  VIEW_APPLICATION_DATA,
  UPDATE_APPLICATION_STATUS,
  VIEW_MENTOR_APPLICATION_DATA,
} from "../../../../common/constants/ApplicationUrl";

const ViewApplication = (props) => {
  const { updatedStatus } = props;
  const [viewApplicationData, setViewApplicationData] = useState();
  // const [applicationStatus, setapplicationStatus] = useState(
  //   props.location.state.applicationStatus
  // );
  const [applicationStatus, setapplicationStatus] = useState(
    window.applicationStatus
  );
  const [students, setStudents] = useState([]);

  const [showSubmitAction, setShowSubmitAction] = useState(false);
  const [action, setAction] = useState();
  const [submitData, setSubmitData] = useState();
  const [selectedColor, setSelectedColor] = useState(false);
  const [selectedColor2, setSelectedColor2] = useState(false);
  const [selectedColor3, setSelectedColor3] = useState(false);
  const loggedInUser = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const onclickShowSubmitAction = (action, id, status) => {
    setShowSubmitAction(true);
    setAction(action);
    let params = {
      id: id,
      status: status,
    };
    setSubmitData(params);
  };

  const clickOnClose = (data) => {
    // alert(data)
    setShowSubmitAction((x) => !x);
  };
  const history = useHistory();
  useEffect(() => {
    // const params = { id: props.location.state.id };
    //

    let params, route, mentorId;

    if (window.id != null && window.id != undefined && window.id != "") {
      params = { id: window.id };
    } else {
      let applnId = window.location.pathname.split("/");
      mentorId = applnId[applnId.length - 1].split("-");
      //

      //
      if (mentorId && mentorId[0] == "mentor") {
        params = { id: mentorId[mentorId.length - 1] };
      } else {
        params = { id: applnId[applnId.length - 1] };
      }
    }
    if (
      window.fromModule === "mentorApplicationList" ||
      window.fromModule === "mentorDashboard"
    ) {
      route = VIEW_APPLICATION_DATA;
    } else if (window.fromModule === "mentorList") {
      route = VIEW_MENTOR_APPLICATION_DATA;
    } else if (mentorId && mentorId[0] == "mentor") {
      route = VIEW_MENTOR_APPLICATION_DATA;
    } else {
      route = VIEW_APPLICATION_DATA;
    }

    api
      .POST(`${route}`, params)
      .then((response) => {
        const { data, status } = response || {};

        if (status === 200) {
          if (response.data.data) setViewApplicationData(response.data.data);
          // return response.data ;
        } else {
          // return { status: false }
        }
      })
      .catch((e) => {
        // return Promise.reject(e);
      });
    // },
  }, []);

  const getMentorId = (string) => {
    const value = string.substring(string.length - 6);
    return "M" + value;
  };

  const getApplicationId = (string) => {
    const value = string.substring(string.length - 6);
    return value;
  };
  useEffect(() => {
    let mentorIdparam = { question: "Mentor Id", answser: "-" };
    if (
      viewApplicationData &&
      viewApplicationData.applicationStatus === "VERIFIED"
    ) {
      mentorIdparam = {
        question: "Mentor Id",
        answser:
          viewApplicationData && getMentorId(viewApplicationData.mentorId),
      };
    }
    let formattedNumber = viewApplicationData?.phone_number.substr(
      2,
      viewApplicationData?.phone_number.length
    );

    // let newNumber = "91" + " " + formattedNumber;
    let newNumber = viewApplicationData?.phone_number;
    let value = [];
    if (
      loggedInUser?.role === "Admin" ||
      loggedInUser?.id == viewApplicationData?.id
    )
      value = [
        mentorIdparam ? mentorIdparam : "",
        {
          question: "Name",
          answser: viewApplicationData && viewApplicationData.full_name,
        },

        {
          question: "Organization Name",
          answser: viewApplicationData && viewApplicationData.organization_name,
        },
        {
          question: "Designation",
          answser:
            viewApplicationData && viewApplicationData.current_designation,
        },
        {
          question: "Email",
          answser: viewApplicationData && viewApplicationData.email_id,
        },

        {
          question: "Contact Number",
          answser: viewApplicationData && "+" + newNumber,
        },
        {
          question: "Gender",
          answser: viewApplicationData && viewApplicationData.gender,
        },
        {
          question: "Country",
          answser: viewApplicationData && viewApplicationData.country_name,
        },
        {
          question: "State",
          answser: viewApplicationData && viewApplicationData?.state_name,
        },
        {
          question: "City",
          answser: viewApplicationData && viewApplicationData.city,
        },
        {
          question:
            "Why do you want to be a mentor at the Startup India mentorship program?",
          answser: viewApplicationData && viewApplicationData.mentoratstartup,
        },
        {
          question:
            "How many hours can you dedicate for providing mentorship per week?",
          answser: viewApplicationData && viewApplicationData.hoursperweek,
        },
        {
          question: "Industry  / Sector",
          answser: viewApplicationData && viewApplicationData.industry,
        },
        {
          question: "Industry / Sector Keywords",
          answser: viewApplicationData && viewApplicationData.subindustry,
        },

        {
          question: "Specialization / Function",
          answser: viewApplicationData && viewApplicationData.specialization,
        },
        {
          question: "Specialization / Function Keywords",
          answser: viewApplicationData && viewApplicationData.subspecialization,
        },
        {
          question: "Preferred stage of the startup",
          answser: viewApplicationData && viewApplicationData.preferredStage,
        },

        {
          question: "LinkedIn",
          answser: viewApplicationData && viewApplicationData.linkedinurl,
        },
        {
          question: "Upload Resume",
          answser:
            viewApplicationData &&
            viewApplicationData.uploadResume &&
            viewApplicationData.uploadResume,
        },
        {
          question: "Personal Blog",
          answser: viewApplicationData && viewApplicationData.personalblogurl,
        },

        {
          question: "Short Description",
          answser: viewApplicationData && viewApplicationData.shortDesription,
        },
      ];
    else
      value = [
        mentorIdparam ? mentorIdparam : "",
        {
          question: "Name",
          answser: viewApplicationData && viewApplicationData.full_name,
        },

        {
          question: "Organization Name",
          answser: viewApplicationData && viewApplicationData.organization_name,
        },
        {
          question: "Designation",
          answser:
            viewApplicationData && viewApplicationData.current_designation,
        },

        {
          question: "Gender",
          answser: viewApplicationData && viewApplicationData.gender,
        },
        {
          question: "Country",
          answser: viewApplicationData && viewApplicationData.country_name,
        },
        {
          question: "State",
          answser: viewApplicationData && viewApplicationData?.state_name,
        },
        {
          question: "City",
          answser: viewApplicationData && viewApplicationData.city,
        },
        {
          question:
            "Why do you want to be a mentor at the Startup India mentorship program?",
          answser: viewApplicationData && viewApplicationData.mentoratstartup,
        },
        {
          question:
            "How many hours can you dedicate for providing mentorship per week?",
          answser: viewApplicationData && viewApplicationData.hoursperweek,
        },
        {
          question: "Industry  / Sector",
          answser: viewApplicationData && viewApplicationData.industry,
        },
        {
          question: "Industry / Sector Keywords",
          answser: viewApplicationData && viewApplicationData.subindustry,
        },

        {
          question: "Specialization / Function",
          answser: viewApplicationData && viewApplicationData.specialization,
        },
        {
          question: "Specialization / Function Keywords",
          answser: viewApplicationData && viewApplicationData.subspecialization,
        },
        {
          question: "Preferred stage of the startup",
          answser: viewApplicationData && viewApplicationData.preferredStage,
        },

        {
          question: "LinkedIn",
          answser: viewApplicationData && viewApplicationData.linkedinurl,
        },
        {
          question: "Upload Resume",
          answser:
            viewApplicationData &&
            viewApplicationData.uploadResume &&
            viewApplicationData.uploadResume,
        },
        {
          question: "Personal Blog",
          answser: viewApplicationData && viewApplicationData.personalblogurl,
        },

        {
          question: "Short Description",
          answser: viewApplicationData && viewApplicationData.shortDesription,
        },
      ];
    setStudents(value);
  }, [viewApplicationData && viewApplicationData.applicationStatus]);

  useEffect(() => {
    if (updatedStatus && updatedStatus.applicationStatus) {
      if (window.applicationStatus !== applicationStatus) {
        history.goBack();
      } else {
        //   history.goBack();
      }
    }
  }, [updatedStatus && updatedStatus.applicationStatus]);

  const clickedOnBack = () => {
    if (window.fromModule === "mentorList") {
      localStorage.setItem("allMentorList", "allMentorList");
      history.push("./dashboard");
    } else if (window.fromModule === "mentorDashboardHome") {
      localStorage.setItem("mentorDashboardHome", "mentorDashboardHome");
      history.push("./dashboard");
    } else {
      localStorage.setItem("mentorMenu", "mentorMenu");
      history.push("./dashboard");
    }
  };
  const renderTableData = () => {
    return students?.map((student, index) => {
      const { id, question, age, answser } = student; //destructuring
      return (
        <tr key={id}>
          <td className="question_name">
            <p>{question}</p>
          </td>
          <td className="anwsers">
            {question === "Industry  / Sector" ||
            question === "Preferred stage of the startup" ||
            question === "Specialization / Function" ||
            question === "Specialization / Function Keywords" ||
            question === "Industry / Sector Keywords" ? (
              answser?.map((item, index) => <p key={index}>{item}</p>)
            ) : question === "Upload Resume" ? (
              answser && (
                <a
                  href={answser}
                  target="_blank"
                  style={{ fontWeight: 700, color: "#3AC2D7" }}
                >
                  {"View Resume"}
                </a>
              )
            ) : question === "LinkedIn" ? (
              answser && (
                <a
                  href={answser}
                  target="_blank"
                  style={{ fontWeight: 700, color: "#3AC2D7" }}
                >
                  {"View LinkedIn Profile"}
                </a>
              )
            ) : question === "Personal Blog" ? (
              answser && (
                <a
                  href={answser}
                  target="_blank"
                  style={{ fontWeight: 700, color: "#3AC2D7" }}
                >
                  {"View Personal Blog"}
                </a>
              )
            ) : (
              <p>{answser}</p>
            )}
          </td>
        </tr>
      );
    });
  };

  const setUpdateApplicationStatus = (action, id, status) => {
    let params = {
      id: id,
      status: status,
      // comments: formData.reason,
    };
    api
      .POST(`${UPDATE_APPLICATION_STATUS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          // localStorage.setItem("mentorMenu", "mentorMenu");

          let text = "Application Accepted Successfully";
          swal("Success", text, "success", { closeOnClickOutside: false }).then(
            function () {
              window.close();
            }
          );
          // history.goBack();
        } else {
          // return { status: false }
        }
      })
      .catch((e) => {
        // return Promise.reject(e);
      });
  };

  return (
    <div className="view_application-main">
      <div class="col-md-10 view_application">
        <div>
          {/* <Button
            className="top-btn"
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "#3AC2D7",
              color: "#fff",
              width: "150px",
              marginTop: "20px",
              marginBottom: "20px",
              marginRight: "8px",
              display: "flex",
              fontFamily: "Montserrat",
              fontSize: "16px",
              fontWeight: 600,
              lineHeight: "25px",
              letterSpacing: "0.02857em",
              textTransform: "uppercase",
            }}
            onClick={() => {
              clickedOnBack();
            }}
          >
            {" "}
            Back
          </Button> */}
          <div className="viewappliphotodiv">
            <p className="display-heading">
              APPLICATION ID :{" "}
              {viewApplicationData && getApplicationId(viewApplicationData.id)}
            </p>
            <img
              className="mentor-img"
              src={
                viewApplicationData &&
                viewApplicationData?.uploadProfilePic !== "null" &&
                viewApplicationData?.uploadProfilePic !== null &&
                viewApplicationData?.uploadProfilePic !== ""
                  ? viewApplicationData?.uploadProfilePic
                  : hashImage
              }
            />
          </div>
        </div>

        <h1 id="title"></h1>
        <table id="students">
          <tbody>{renderTableData()}</tbody>
        </table>
        {window.fromModule === "mentorDashboardHome" ||
        window.fromModule === "mentorDashboard" ? (
          <div></div>
        ) : viewApplicationData?.applicationStatus === "VERIFIED" ? (
          <div>{/* { alert("test b")} */}</div>
        ) : viewApplicationData?.applicationStatus === "SUBMITTED" ||
          viewApplicationData?.applicationStatus === "UPDATEDINFO" ? (
          <div>
            <a
              onClick={() => {
                setSelectedColor(true);
                setSelectedColor2(false);
                setSelectedColor3(false);
                setUpdateApplicationStatus("Approve", window.id, "VERIFIED");
              }}
              className="brd-btn d-inline-block newbtnbottom"
              style={{
                backgroundColor: "#f4f4f4",
                color: selectedColor === true ? "#fff" : "#3AC2D7",
                width: "10.5em",
                marginTop: "20px",
                marginRight: "8px",
                border: selectedColor === true ? "0px" : "1px solid #00000040",
                borderRadius: "5px",
                paddingTop: "6px",
                paddingBottom: "6px",
                cursor: "pointer",
              }}
              title=""
            >
              APPROVE
            </a>

            <a
              onClick={() => {
                setSelectedColor2(true);
                setSelectedColor(false);
                setSelectedColor3(false);
                onclickShowSubmitAction("Approve", window.id, "REJECTED");
              }}
              className="brd-btn d-inline-block newbtnbottom"
              style={{
                backgroundColor: "#f4f4f4",
                // backgroundColor: "#f4f4f4",
                color: selectedColor === true ? "#fff" : "#3AC2D7",
                // color: "#3AC2D7",
                width: "10.5em",
                marginTop: "20px",
                marginRight: "8px",
                border: selectedColor === true ? "0px" : "1px solid #00000040",
                borderRadius: "5px",
                paddingTop: "6px",
                paddingBottom: "6px",
              }}
              href="javascript:void(0)"
              title=""
            >
              REJECT
            </a>

            <a
              onClick={() => {
                setSelectedColor3(true);
                setSelectedColor(false);
                setSelectedColor2(false);
                onclickShowSubmitAction("Approve", window.id, "REQUESTINFO");
              }}
              className="brd-btn d-inline-block newbtnbottom"
              style={{
                backgroundColor: "#f4f4f4",
                color: selectedColor === true ? "#fff" : "#3AC2D7",
                width: "10.5em",
                marginTop: "20px",
                marginRight: "8px",
                border: selectedColor === true ? "0px" : "1px solid #00000040",
                borderRadius: "5px",
                paddingTop: "6px",
                paddingBottom: "6px",
              }}
              href="javascript:void(0)"
              title=""
            >
              REQUEST INFO
            </a>
          </div>
        ) : (
          ""
        )}
      </div>
      <SubmitAction
        isOpen={showSubmitAction}
        className={"form-submit-modal"}
        onClose={clickOnClose}
        action={action}
        submitData={submitData}
        formName={"mentor-form"}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    applicationData: state.AdminMentorViewReducer.getViewApplicationData.data,
    updatedStatus: state.AdminMentorViewReducer.updateApplicationStatus.data,
  };
};

export default connect(mapStateToProps, {
  getViewApplicationData,
  updateApplicationStatus,
})(withRouter(ViewApplication));
